import axiosClient from './axios-client';
import { API_ENDPOINTS } from '@/constants';

export interface GlobalSearchHit {
  id: string;
  label: string;
  detail?: string;
  amount?: string | null;
  status?: string | null;
}

export interface GlobalSearchResults {
  query: string;
  orders: GlobalSearchHit[];
  products: GlobalSearchHit[];
  invoices: GlobalSearchHit[];
  customers: GlobalSearchHit[];
}

export const searchApi = {
  global: async (q: string, limit = 5): Promise<GlobalSearchResults> => {
    const response = await axiosClient.get<GlobalSearchResults>(
      API_ENDPOINTS.SEARCH,
      { params: { q, limit } },
    );
    return response.data;
  },
};
